import './NotFound.scss'
import logo from '../../assets/logo.png'
import image404 from '../../assets/404.png'
import { Link, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { useDeviceSelectors } from 'react-device-detect'

const NotFound = () => {
  const [selectors] = useDeviceSelectors(window.navigator.userAgent)
  const location = useLocation();

  useEffect(() => {
    let from = location.state || '';

    if (selectors.isIOS && from.includes('share')) {
      window.location.href = 'https://apps.apple.com/kz/app/totem-chat/id6444722452'
    }
  }, [selectors.isIOS, location])

  return (
    <div className='not-found'>
      <header className='header not-found__header'>
        <Link to="/">
          <img src={logo} className='logo' alt='logo' />
        </Link>
      </header>
      <main className='main'>
        <div className='main__left'>
          <h1 className='main__title'>Упс... ошибочка</h1>
          <p className='main__subtitle'>Возможно эта страница устарела, была удалена, либо неправильно набран адрес</p>
          <Link to="/" className='main__link'>
            <button className='default-button main__button'>Вернуться на главную</button>
          </Link>
        </div>
        <div className="main__right">
          <img src={image404} alt='404' className='main__image'/>
        </div>
      </main>
    </div>
  )
}

export default NotFound
